import React from 'react'
import Lottie from 'lottie-react';
import checkMark from './checkmark.json';
import { Box, Stack, Button, Typography } from '@mui/material';
import { config } from '../../config';


export default function ThankYou() {
  return (
    <Stack 
        alignItems={'center'}
        justifyContent={'center'}
        sx={{
            minHeight: 'calc(100vh - 140px)',
            background: 'rgb(43, 43, 80)',
        }}
    > 
        <Stack justifyContent={'center'} className='contained' alignItems={'center'}>
            {/* Lottie */}
            <Box
                sx={{
                    width: {xs: 200, md: 400},
                    height: {xs: 200, md: 400},
                }}
            >
                <Lottie animationData={checkMark} loop={true} />
            </Box>

            <Typography textAlign={'center'} sx={{
                mb: {xs: 2, md: 5}
            }} color={config.colors.white}>Tack för din ansöka! Vi återkommer så snart vi kan!</Typography>

            <Button
                variant="contained"
                href='/'
                sx={{ 
                    mt: { xs: 2, md: 0}, 
                    mb: 2, 
                    borderRadius: "10px", 
                    padding: "12px 25px", 
                    fontWeight: "600", 
                    width: "fit-content", 
                    fontSize: '13px',
                    backgroundColor: 'white', 
                    color: 'black', 
                    transition: 'background-color 500ms, color 500ms',
                    '&:hover': {
                    background: config.colors.secondary,
                    color: config.colors.white
                    },
                    ":disabled": {
                    backgroundColor: "white", 
                    opacity: .7 
                }}}
                >
                Till karriär {/* Change button text based on loading state */}
            </Button>
        </Stack>
    </Stack>
  )
}
